var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlugIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 48.125L13.1042 42.3958M42.8958 12.6042L48.625 6.875M23.4167 25.2083L18.8333 29.7917M30.2917 32.0833L25.7083 36.6667M16.5415 27.5L27.9999 38.9583L24.5624 42.3958C23.8145 43.1684 22.9204 43.7844 21.9321 44.2079C20.9438 44.6314 19.8811 44.854 18.8059 44.8628C17.7308 44.8715 16.6646 44.6662 15.6696 44.2587C14.6745 43.8513 13.7705 43.2499 13.0102 42.4896C12.2499 41.7293 11.6486 40.8253 11.2411 39.8303C10.8337 38.8353 10.6284 37.7691 10.6371 36.6939C10.6458 35.6187 10.8684 34.556 11.292 33.5678C11.7155 32.5795 12.3315 31.6853 13.104 30.9375L16.5415 27.5ZM39.4583 27.4999L28 16.0415L31.4375 12.604C32.1853 11.8315 33.0795 11.2155 34.0678 10.792C35.056 10.3684 36.1187 10.1458 37.1939 10.1371C38.2691 10.1284 39.3353 10.3337 40.3303 10.7411C41.3253 11.1486 42.2293 11.7499 42.9896 12.5102C43.7499 13.2705 44.3513 14.1745 44.7587 15.1696C45.1662 16.1646 45.3715 17.2308 45.3628 18.3059C45.354 19.3811 45.1314 20.4438 44.7079 21.4321C44.2844 22.4204 43.6684 23.3145 42.8958 24.0624L39.4583 27.4999Z",
    stroke: "#199CB5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugIcon);
export default __webpack_public_path__ + "static/media/plug-icon.9dc091bcb83fb62a4e41d9463dc8c66e.svg";
export { ForwardRef as ReactComponent };